/* eslint-disable @typescript-eslint/no-explicit-any */
import {CreateWorkspaceRequest} from "../model/request/workspace/CreateWorkspaceRequest.ts";
import {BaseService} from "./BaseService.ts";
import {UpdateWorkSpaceRequest} from "../model/request/workspace/UpdateWorkSpaceRequest.ts";
import {DeleteWorkSpaceRequest} from "../model/request/workspace/DeleteWorkSpaceRequest.tsx";
import {ReadByUserIdRequest} from "../model/request/workspace/ReadByUserIdRequest.ts";


export class WorkspaceService {
    static create = (others: any, data: CreateWorkspaceRequest) => {
        return BaseService.apiClient(others).post("/workspace/create", data);
    };
    static read = (others: any) => {
        return BaseService.apiClient(others).get("/workspace/read");
    };
    static readByUserId = (others: any, data: ReadByUserIdRequest) => {
        return BaseService.apiClient(others).get(`/workspace/read-by-workspace-user-id/${data.userId}`);
    };
    static update = (others: any, data: UpdateWorkSpaceRequest) => {
        return BaseService.apiClient(others).post("workspace/update", data);
    }
    static delete = (others: any, data: DeleteWorkSpaceRequest) => {
        return BaseService.apiClient(others).post("/workspace/delete", data);
    }
}
